const rtlCharacter = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
const ltrCharacter = /[A-Za-z]/;

export const getTextDirection = (value) => {
    const text = String(value || '');
    const rtlIndex = text.search(rtlCharacter);
    const ltrIndex = text.search(ltrCharacter);

    if (rtlIndex === -1 && ltrIndex === -1) return 'rtl';
    if (rtlIndex === -1) return 'ltr';
    if (ltrIndex === -1) return 'rtl';
    return rtlIndex < ltrIndex ? 'rtl' : 'ltr';
};
